{
  "name": "@hey-api/openapi-ts",
  "version": "0.86.11",
  "description": "🚀 The OpenAPI to TypeScript codegen. Generate clients, SDKs, validators, and more.",
  "homepage": "https://heyapi.dev/",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/hey-api/openapi-ts.git"
  },
  "bugs": {
    "url": "https://github.com/hey-api/openapi-ts/issues"
  },
  "license": "MIT",
  "author": {
    "email": "lubos@heyapi.dev",
    "name": "Hey API",
    "url": "https://heyapi.dev"
  },
  "funding": "https://github.com/sponsors/hey-api",
  "keywords": [
    "angular",
    "axios",
    "codegen",
    "fetch",
    "generator",
    "http",
    "javascript",
    "json",
    "next",
    "next.js",
    "node",
    "nuxt",
    "ofetch",
    "openapi",
    "rest",
    "swagger",
    "typescript",
    "xhr",
    "yaml"
  ],
  "type": "module",
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      },
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      }
    },
    "./internal": {
      "import": {
        "types": "./dist/internal.d.ts",
        "default": "./dist/internal.js"
      },
      "require": {
        "types": "./dist/internal.d.cts",
        "default": "./dist/internal.cjs"
      }
    },
    "./package.json": "./package.json"
  },
  "bin": {
    "openapi-ts": "./bin/run.js"
  },
  "files": [
    "bin",
    "dist",
    "LICENSE.md",
    "README.md"
  ],
  "scripts": {
    "build": "tsdown && pnpm check-exports",
    "check-exports": "attw --pack . --profile node16",
    "dev": "tsdown --watch",
    "handlebars": "node src/legacy/handlebars/handlebars.cjs",
    "prepublishOnly": "pnpm build",
    "test:coverage": "vitest run --coverage",
    "test:update": "vitest watch --update",
    "test:watch": "vitest watch",
    "test": "vitest run",
    "typecheck": "tsc --noEmit"
  },
  "engines": {
    "node": ">=20.19.0"
  },
  "dependencies": {
    "@hey-api/codegen-core": "workspace:^0.3.2",
    "@hey-api/json-schema-ref-parser": "1.2.1",
    "ansi-colors": "4.1.3",
    "c12": "3.3.1",
    "color-support": "1.1.3",
    "commander": "14.0.1",
    "handlebars": "4.7.8",
    "open": "10.2.0",
    "semver": "7.7.2"
  },
  "peerDependencies": {
    "typescript": ">=5.5.3"
  },
  "devDependencies": {
    "@angular/common": "19.2.15",
    "@angular/compiler": "19.2.15",
    "@angular/compiler-cli": "19.2.15",
    "@angular/core": "19.2.15",
    "@angular/platform-browser": "19.2.15",
    "@angular/platform-browser-dynamic": "19.2.15",
    "@angular/router": "19.2.15",
    "@config/vite-base": "workspace:*",
    "@types/bun": "1.3.1",
    "@types/cross-spawn": "6.0.6",
    "@types/semver": "7.7.1",
    "axios": "1.8.2",
    "cross-spawn": "7.0.6",
    "eslint": "9.17.0",
    "glob": "11.0.3",
    "nuxt": "3.14.1592",
    "ofetch": "1.4.1",
    "prettier": "3.4.2",
    "rxjs": "7.8.2",
    "typescript": "5.9.3",
    "vue": "3.5.13",
    "yaml": "2.8.0",
    "zone.js": "0.15.1"
  }
}
